export default "__VITE_ASSET__DVkGUNO3__"